export default __webpack_public_path__ + "static/media/polaroid6.360609cb.svg";